import { ProjectScopeTableColumns, ProjectScopeTable } from "@/features/projectScope";

export default function ProjectScope() {
  const columns = ProjectScopeTableColumns();

  return <ProjectScopeTable columns={columns} />;
}
